import {
  MinimumStationsGroup,
  Station,
  StationAccessType,
  StationGroupAccessType,
} from '@app/core/types/stations';

export function isVideoStation(station: Station) {
  return station?.format === 'mpegts';
}

/** Returns true when the station streams directly to YouTube (YouTube Native integration). */
export function isYoutubeNativeStation(station: Station) {
  return station.youtubeNative;
}

export function isAudioStation(station: Station) {
  return !isVideoStation(station);
}

/**
 * Returns true when the station is owned by the authenticated client.
 */
export function isOwnedStation(station: Station) {
  return station.accessType === StationAccessType.OWNED;
}

/**
 * Returns true when the station is shared from another client.
 */
export function isSharedStation(station: Station) {
  return station.accessType === StationAccessType.SHARED;
}

/**
 * Returns true when the station group is shared from another client.
 */
export function isSharedStationGroup(group: MinimumStationsGroup) {
  return group.accessType === StationGroupAccessType.SHARED;
}

/**
 * Defines whether write-capable station surfaces should be shown.
 */
export function canEditStation(station: Station) {
  return isOwnedStation(station);
}
